/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EventUpdates/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function EventUpdates({
  children,
  viewPath = "/App/Account/Content/Calendar/New/EventUpdates"
  
}) {
  return null
}